import { Box, Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import React from "react";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { isNotEmpty } from "../../Utils";
import CustomDatePicker from "../../component/CustomDatePicker/CustomDatePicker";
import FormBox from "../../component/FormBox/FormBox";
import CustomSelect from "../../inputComponent/CustomSelect/CustomSelect";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import DistrictFields from "./ParameterTemplate100/DistrictFields";
import LocationAndItemFields from "./ParameterTemplate100/LocationAndItemFields";

const useStyles = makeStyles({
    container: {
        maxHeight: 250,
    },
    label: {
        paddingRight: 10,
        paddingTop: 9,
    },
    dateLabel: {
        paddingRight: 10,
        paddingTop: 5,
    },
    removeBtn: {
        position: "absolute",
        right: "10px",
        bottom: "10px",
    },
});

function ParameterTemplate100({
    defaultValues,
    register,
    control,
    errors,
    getValues,
    watch,
}) {
    const classes = useStyles();
    const { t } = useTranslation();

    const exerciseFieldArray = useFieldArray({
        control,
        name: "exercise",
    });
    const handleRemoveList = (index) => {
        exerciseFieldArray.remove(index);
    };

    const handleAppendList = () => {
        exerciseFieldArray.append(
            {
                // noInEformTitle: "",
                allocationType: "",
                schoolyear: "",
                copies: "",
                pages: "",
                type: "",
                financeType: {
                    enText: "",
                    scText: "",
                    tcText: "",
                },
                startDate: "",
                endDate: "",
                noInPdfTitle: {
                    enText: "",
                    scText: "",
                    tcText: "",
                },
                district: [
                    {
                        enText: "",
                        scText: "",
                        tcText: "",
                    },
                ],
                item: [
                    {
                        enText: "",
                        scText: "",
                        tcText: "",
                    },
                ],
                location: [
                    {
                        enText: "",
                        scText: "",
                        tcText: "",
                    },
                ],
                noOfPremisesAvailable: "",
                pdfLink: "",
            },
            { shouldFocus: false }
        );
    };

    return (
        <>
            <FormBox>
                <Box p={5}>
                    {exerciseFieldArray.fields.map(
                        (exercise, exerciseIndex) => {
                            return (
                                <FormBox key={exerciseIndex}>
                                    <Box p={5} style={{ position: "relative" }}>
                                        <Grid container>
                                            <Grid
                                                item
                                                xs={3}
                                                className={classes.label}
                                            >
                                                {t("Form100.label.type")}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <CustomSelect
                                                    inlineText
                                                    control={control}
                                                    defaultValue={
                                                        defaultValues
                                                            ?.exercise?.[
                                                            exerciseIndex
                                                        ]?.type
                                                    }
                                                    name={`exercise.${exerciseIndex}.type`}
                                                    inputProps={{
                                                        ...register(
                                                            `exercise.${exerciseIndex}.type`,
                                                            {
                                                                required:
                                                                    t(
                                                                        "errorMsg.required"
                                                                    ),
                                                            }
                                                        ),
                                                    }}
                                                    options={t(
                                                        "Form100.label.typeOptions",
                                                        {
                                                            returnObjects: true,
                                                        }
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid
                                                item
                                                xs={3}
                                                className={classes.label}
                                            >
                                                {t(
                                                    "Form100.label.eligibleSchoolType"
                                                ) + t("common.colon")}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Box
                                                    display={"flex"}
                                                    key={exerciseIndex}
                                                    style={{
                                                        position: "relative",
                                                    }}
                                                >
                                                    <CustomTextField
                                                        inputProps={{
                                                            ...register(
                                                                `exercise.${exerciseIndex}.financeType.enText`
                                                                // {
                                                                //     required:
                                                                //         t(
                                                                //             "errorMsg.required"
                                                                //         ),
                                                                // }
                                                            ),
                                                            autoComplete: "off",
                                                        }}
                                                        placeholder={t(
                                                            `common.en`
                                                        )}
                                                        style={{
                                                            marginRight: "10px",
                                                        }}
                                                        // error={
                                                        //     errors?.exercise?.[
                                                        //         exerciseIndex
                                                        //     ]?.financeType
                                                        //         ?.enText
                                                        // }
                                                    />
                                                    <CustomTextField
                                                        inputProps={{
                                                            ...register(
                                                                `exercise.${exerciseIndex}.financeType.scText`
                                                                // {
                                                                //     required:
                                                                //         t(
                                                                //             "errorMsg.required"
                                                                //         ),
                                                                // }
                                                            ),
                                                            autoComplete: "off",
                                                        }}
                                                        placeholder={t(
                                                            `common.sc`
                                                        )}
                                                        style={{
                                                            marginRight: "10px",
                                                        }}
                                                        // error={
                                                        //     errors?.exercise?.[
                                                        //         exerciseIndex
                                                        //     ]?.financeType
                                                        //         ?.scText
                                                        // }
                                                    />
                                                    <CustomTextField
                                                        inputProps={{
                                                            ...register(
                                                                `exercise.${exerciseIndex}.financeType.tcText`
                                                                // {
                                                                //     required:
                                                                //         t(
                                                                //             "errorMsg.required"
                                                                //         ),
                                                                // }
                                                            ),
                                                            autoComplete: "off",
                                                        }}
                                                        placeholder={t(
                                                            `common.tc`
                                                        )}
                                                        // error={
                                                        //     errors?.exercise?.[
                                                        //         exerciseIndex
                                                        //     ]?.financeType
                                                        //         ?.tcText
                                                        // }
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            style={{ marginBottom: "10px" }}
                                        >
                                            <Grid
                                                item
                                                xs={3}
                                                className={classes.label}
                                            >
                                                {t(
                                                    "Form100.label.allocationType"
                                                ) + t("common.colon")}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <CustomSelect
                                                    inlineText
                                                    control={control}
                                                    defaultValue={
                                                        defaultValues
                                                            ?.exercise?.[
                                                            exerciseIndex
                                                        ]?.allocationType
                                                    }
                                                    name={`exercise.${exerciseIndex}.allocationType`}
                                                    inputProps={{
                                                        ...register(
                                                            `exercise.${exerciseIndex}.allocationType`,
                                                            {
                                                                required:
                                                                    t(
                                                                        "errorMsg.required"
                                                                    ),
                                                            }
                                                        ),
                                                    }}
                                                    options={t(
                                                        "Form100.label.allocationTypeOp",
                                                        {
                                                            returnObjects: true,
                                                        }
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Box mt={4}>
                                            <Grid container>
                                                <Grid
                                                    item
                                                    xs={3}
                                                    className={
                                                        classes.dateLabel
                                                    }
                                                >
                                                    {t(
                                                        "Form100.label.exercisePeriod"
                                                    )}
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                        paddingTop: "5px",
                                                    }}
                                                >
                                                    <Box display={"flex"}>
                                                        <CustomDatePicker
                                                            control={control}
                                                            name={`exercise.${exerciseIndex}.startDate`}
                                                            inputProps={{
                                                                ...register(
                                                                    `exercise.${exerciseIndex}.startDate`,
                                                                    {
                                                                        required:
                                                                            t(
                                                                                "errorMsg.required"
                                                                            ),
                                                                        validate:
                                                                            {
                                                                                earlierThanEnd:
                                                                                    (
                                                                                        date
                                                                                    ) => {
                                                                                        const endData =
                                                                                            getValues(
                                                                                                `exercise.${exerciseIndex}.endDate`
                                                                                            );
                                                                                        return (
                                                                                            isNotEmpty(
                                                                                                endData
                                                                                            ) &&
                                                                                            (moment(
                                                                                                endData
                                                                                            ).diff(
                                                                                                moment(
                                                                                                    date
                                                                                                ),
                                                                                                "days"
                                                                                            ) >=
                                                                                                0 ||
                                                                                                t(
                                                                                                    "errorMsg.date.beforeThisDate",
                                                                                                    {
                                                                                                        targetDate: `${moment(
                                                                                                            endData
                                                                                                        ).format(
                                                                                                            "DD/MM/YYYY"
                                                                                                        )}`,
                                                                                                    }
                                                                                                ))
                                                                                        );
                                                                                    },
                                                                            },
                                                                    }
                                                                ),
                                                            }}
                                                            type="day"
                                                        />
                                                        <span
                                                            style={{
                                                                margin: "0 5px",
                                                            }}
                                                        >
                                                            {t(
                                                                "Form100.label.to"
                                                            )}
                                                        </span>
                                                        <CustomDatePicker
                                                            control={control}
                                                            name={`exercise.${exerciseIndex}.endDate`}
                                                            inputProps={{
                                                                ...register(
                                                                    `exercise.${exerciseIndex}.endDate`,
                                                                    {
                                                                        required:
                                                                            t(
                                                                                "errorMsg.required"
                                                                            ),
                                                                        validate:
                                                                            {
                                                                                laterThanStart:
                                                                                    (
                                                                                        date
                                                                                    ) => {
                                                                                        const startDate =
                                                                                            getValues(
                                                                                                `exercise.${exerciseIndex}.startDate`
                                                                                            );
                                                                                        return (
                                                                                            isNotEmpty(
                                                                                                startDate
                                                                                            ) &&
                                                                                            (moment(
                                                                                                date
                                                                                            ).diff(
                                                                                                moment(
                                                                                                    startDate
                                                                                                ),
                                                                                                "days"
                                                                                            ) >=
                                                                                                0 ||
                                                                                                t(
                                                                                                    "errorMsg.date.afterThisDate",
                                                                                                    {
                                                                                                        targetDate: `${moment(
                                                                                                            startDate
                                                                                                        ).format(
                                                                                                            "DD/MM/YYYY"
                                                                                                        )}`,
                                                                                                    }
                                                                                                ))
                                                                                        );
                                                                                    },
                                                                            },
                                                                    }
                                                                ),
                                                            }}
                                                            type="day"
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        {/* <Grid container>
                                            <Grid
                                                item
                                                xs={3}
                                                className={classes.label}
                                            >
                                                {t(
                                                    "Form100.label.noInEformTitle"
                                                ) + t("common.colon")}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <CustomTextField
                                                    inputProps={{
                                                        ...register(
                                                            `exercise.${exerciseIndex}.noInEformTitle`,
                                                            {
                                                                required:
                                                                    t(
                                                                        "errorMsg.required"
                                                                    ),
                                                            }
                                                        ),
                                                        autoComplete: "off",
                                                    }}
                                                    error={
                                                        errors?.exercise?.[
                                                            exerciseIndex
                                                        ]?.noInEformTitle
                                                    }
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid> */}
                                        <Grid container>
                                            <Grid
                                                item
                                                xs={3}
                                                className={classes.label}
                                            >
                                                {t("Form100.label.year")}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <CustomTextField
                                                    inputProps={{
                                                        ...register(
                                                            `exercise.${exerciseIndex}.schoolyear`,
                                                            {
                                                                required:
                                                                    t(
                                                                        "errorMsg.required"
                                                                    ),
                                                            }
                                                        ),
                                                        autoComplete: "off",
                                                    }}
                                                    error={
                                                        errors?.exercise?.[
                                                            exerciseIndex
                                                        ]?.schoolyear
                                                    }
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid
                                                item
                                                xs={3}
                                                className={classes.label}
                                            >
                                                {t(
                                                    "Form100.label.allocationNo"
                                                ) + t("common.colon")}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Box
                                                    display={"flex"}
                                                    key={exerciseIndex}
                                                    style={{
                                                        position: "relative",
                                                    }}
                                                >
                                                    <CustomTextField
                                                        inputProps={{
                                                            ...register(
                                                                `exercise.${exerciseIndex}.noInPdfTitle.enText`,
                                                                {
                                                                    required:
                                                                        t(
                                                                            "errorMsg.required"
                                                                        ),
                                                                }
                                                            ),
                                                            autoComplete: "off",
                                                        }}
                                                        placeholder={t(
                                                            `common.en`
                                                        )}
                                                        style={{
                                                            marginRight: "10px",
                                                        }}
                                                        error={
                                                            errors?.exercise?.[
                                                                exerciseIndex
                                                            ]?.noInPdfTitle
                                                                ?.enText
                                                        }
                                                    />
                                                    <CustomTextField
                                                        inputProps={{
                                                            ...register(
                                                                `exercise.${exerciseIndex}.noInPdfTitle.scText`,
                                                                {
                                                                    required:
                                                                        t(
                                                                            "errorMsg.required"
                                                                        ),
                                                                }
                                                            ),
                                                            autoComplete: "off",
                                                        }}
                                                        placeholder={t(
                                                            `common.sc`
                                                        )}
                                                        style={{
                                                            marginRight: "10px",
                                                        }}
                                                        error={
                                                            errors?.exercise?.[
                                                                exerciseIndex
                                                            ]?.noInPdfTitle
                                                                ?.scText
                                                        }
                                                    />
                                                    <CustomTextField
                                                        inputProps={{
                                                            ...register(
                                                                `exercise.${exerciseIndex}.noInPdfTitle.tcText`,
                                                                {
                                                                    required:
                                                                        t(
                                                                            "errorMsg.required"
                                                                        ),
                                                                }
                                                            ),
                                                            autoComplete: "off",
                                                        }}
                                                        placeholder={t(
                                                            `common.tc`
                                                        )}
                                                        error={
                                                            errors?.exercise?.[
                                                                exerciseIndex
                                                            ]?.noInPdfTitle
                                                                ?.tcText
                                                        }
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid
                                                item
                                                xs={3}
                                                className={classes.label}
                                            >
                                                {t("Form100.label.copies") +
                                                    t("common.colon")}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <CustomTextField
                                                    inputProps={{
                                                        ...register(
                                                            `exercise.${exerciseIndex}.copies`,
                                                            {
                                                                required:
                                                                    t(
                                                                        "errorMsg.required"
                                                                    ),
                                                            }
                                                        ),
                                                        autoComplete: "off",
                                                    }}
                                                    error={
                                                        errors?.exercise?.[
                                                            exerciseIndex
                                                        ]?.copies
                                                    }
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid
                                                item
                                                xs={3}
                                                className={classes.label}
                                            >
                                                {t("Form100.label.pages") +
                                                    t("common.colon")}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <CustomTextField
                                                    inputProps={{
                                                        ...register(
                                                            `exercise.${exerciseIndex}.pages`,
                                                            {
                                                                required:
                                                                    t(
                                                                        "errorMsg.required"
                                                                    ),
                                                            }
                                                        ),
                                                        autoComplete: "off",
                                                    }}
                                                    error={
                                                        errors?.exercise?.[
                                                            exerciseIndex
                                                        ]?.pages
                                                    }
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                        <Box mt={4}>
                                            <DistrictFields
                                                classes={classes}
                                                control={control}
                                                register={register}
                                                errors={errors}
                                                exerciseIndex={exerciseIndex}
                                                getValues={getValues}
                                            />
                                        </Box>
                                        <Box mt={4}>
                                            <LocationAndItemFields
                                                classes={classes}
                                                control={control}
                                                register={register}
                                                errors={errors}
                                                exerciseIndex={exerciseIndex}
                                                getValues={getValues}
                                            />
                                        </Box>
                                        <Grid container>
                                            <Grid
                                                item
                                                xs={3}
                                                className={classes.label}
                                            >
                                                {t(
                                                    "Form100.label.noOfPremisesAvailable"
                                                )}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <CustomTextField
                                                    inputProps={{
                                                        ...register(
                                                            `exercise.${exerciseIndex}.noOfPremisesAvailable`,
                                                            {
                                                                required:
                                                                    t(
                                                                        "errorMsg.required"
                                                                    ),
                                                            }
                                                        ),
                                                        autoComplete: "off",
                                                    }}
                                                    error={
                                                        errors?.exercise?.[
                                                            exerciseIndex
                                                        ]?.noOfPremisesAvailable
                                                    }
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid
                                                item
                                                xs={3}
                                                className={classes.label}
                                            >
                                                {t("Form100.label.pdfLink")}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <CustomTextField
                                                    inputProps={{
                                                        ...register(
                                                            `exercise.${exerciseIndex}.pdfLink`,
                                                            {
                                                                required:
                                                                    t(
                                                                        "errorMsg.required"
                                                                    ),
                                                            }
                                                        ),
                                                        autoComplete: "off",
                                                    }}
                                                    fullWidth
                                                    error={
                                                        errors?.exercise?.[
                                                            exerciseIndex
                                                        ]?.pdfLink
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                        <Button
                                            className={classes.removeBtn}
                                            onClick={() => {
                                                handleRemoveList(exerciseIndex);
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            {t("common.button.remove")}
                                        </Button>
                                    </Box>
                                </FormBox>
                            );
                        }
                    )}
                    {exerciseFieldArray.fields.length < 5 && (
                        <Box mt={6}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleAppendList}
                            >
                                {t("Form100.label.addExercise")}
                            </Button>
                        </Box>
                    )}
                </Box>
            </FormBox>
        </>
    );
}

export default ParameterTemplate100;
